/*
 * @Description:
 * @Date: 2021-10-20 11:43:02
 */
import { FaceAuthAgreement, FaceAuthResult } from '../app';
import { RouterTransition } from '@/components/transition';
import { FaceRouteName } from '../types';

export const route = [
  {
    path: '/face-auth',
    name: 'face-auth',
    redirect: '/face-auth/face-agreement',
    component: RouterTransition,
    meta: {
      title: '活体认证'
    },
    children: [
      {
        path: '/face-auth/face-agreement',
        name: FaceRouteName.agreement,
        meta: {
          needLogin: false,
          pageName: '身份验证',
          title: '身份验证'
        },
        component: FaceAuthAgreement
      },
      {
        path: '/face-auth/face-result',
        name: FaceRouteName.result,
        meta: {
          needLogin: false,
          pageName: '结果验证',
          title: '结果验证'
        },
        component: FaceAuthResult
      }
    ]
  }
];
